<div class="card-promotion h-100 w-100 d-flex flex-column">
    <span class="cardp-title">
        <img [alt]="'tag-img'" [src]="'images/etiqueta.svg' | cdn" />
        {{ 'fe_promotionscard_span_head-title' | translate }}
    </span>
    <a
        class="link-card"
        [routerLink]="('promos-and-agreements/' | formatUrl) + promotion.code"
    >
        <span>{{ promotion.subTitle }}</span>
        <img
            [alt]="'arrow left img'"
            [src]="'images/flecha_links_morada.svg' | cdn"
        />
    </a>
    <ul class="card-list">
        <li class="card-item-list" *ngFor="let item of promotion.list">
            {{ item }}
        </li>
    </ul>
    <p>
        {{
            'fe_promotionscard_valid'
                | translate
                | replace
                    : {
                          startAndEndDate:
                              (promotion.startDate
                              | formatBookingDates: promotion.endDate)
                      }
        }}
    </p>
</div>
